import Avatar from '../components/avatar';
import Dialog from '../components/dialog';
import RadioDescription from '../components/radio-description';

module.exports = {
  Avatar,
  CoverImage: require('../components/cover-image'),
  CoverUpload: require('../components/cover-upload'),
  CustomCheckbox: require('../components/custom-checkbox'),
  DateDropdown: require('../components/date-dropdown'),
  DatePicker: require('../components/date-picker'),
  DateRangePicker: require('../components/date-range-picker'),
  Dialog,
  GalleryOverlay: require('../components/gallery-overlay'),
  HourPicker: require('../components/hour-picker'),
  Loading: require('../components/loading'),
  Navigation: require('../components/navigation'),
  NavigationBar: require('../components/navigation-bar'),
  RadioDescription,
  Search: require('../components/search'),
  SettingsDropdown: require('../components/settings-dropdown'),
  SimpleTable: require('../components/simple-table'),
  SocialAvatar: require('../components/social-avatar'),
  Table: require('../components/table'),
  Tag: require('../components/tag'),
  Toggle: require('../components/toggle'),
  Tooltip: require('../components/tooltip'),
  UnavailableSection: require('../components/unavailable-section'),
  UploadImage: require('../components/upload-image'),
  UploadAvatar: require('../components/upload-avatar'),
  UploadAvatarContainer: require('../components/upload-avatar-container'),
  Wizard: require('../components/wizard'),
  WizardItem: require('../components/wizard-item')
};
